import { connect } from 'react-redux'
import { BillingBillsComponent } from './BillingBills'
import showBillingCreateFormModal from 'features/Billing/BillingCreateFormModal'

const stateToProps = ({ billing: { billingAccounts } }) => ({ billingAccounts })

export const dispatchToProps = {
  showBillingCreateFormModal,
}

export const BillingBills = connect(stateToProps, dispatchToProps)(BillingBillsComponent)



// WEBPACK FOOTER //
// src/pages/BillingBills/BillingBills.container.ts